import { create } from 'zustand';

import { fetchLanguageList, fetchUserSettings } from '@/service/language';
import type { LanguageItem } from '@/service/language';

interface TypeUserSettings {
  languageList: LanguageItem[];
  preferredLanguage: string;
  userLanguage: string;
  initLanguage: () => void;
  fetchUserLanguage: () => void;
}

const useUserSettings = create<TypeUserSettings>()((set, get) => ({
  languageList: [] as LanguageItem[],
  preferredLanguage: '',
  userLanguage: '',

  initLanguage: () => {
    fetchLanguageList().then((res) => {
      const list = res.data.data || [];

      set({ languageList: list });
    });

    get().fetchUserLanguage();
  },

  fetchUserLanguage: () => {
    fetchUserSettings().then((res) => {
      set({
        preferredLanguage: res.data.data?.preferredLanguage || 'en',
        userLanguage: res.data.data?.userLanguage || 'en'
      });
    });
  }
}));

export default useUserSettings;
